import { useMemo } from 'react';

import { RoverBrand } from '@rover/types/src/RoverBrand';

import ciafTheme from '../ciafTheme';
import roverTheme from '../roverTheme';
import { ThemeWithBreakpoints } from '../themeConstants';

export type BrandThemeProviderProps = {
  brand?: RoverBrand;
  children: React.ReactNode;
};

export const useBrandThemeMemo = (brand: RoverBrand): ThemeWithBreakpoints => {
  return useMemo(() => {
    switch (brand) {
      case RoverBrand.CatInAFlat:
        return ciafTheme;
      case RoverBrand.Rover:
      default:
        return roverTheme;
    }
  }, [brand]);
};
